(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-image-only"] && !window.DesignMode) return;
  try {
    
  let bloaded = true;
  let isxMobile = false;
  if ("ontouchstart" in document.documentElement) {
    isxMobile = true;
    mobileb = $('#banner-image-only').data('srcmobile');
  }
  console.log(isxMobile,'isxMobile');
  var hbno = isxMobile ? mobileb : $('#banner-image-only').data('src');
  var hbnow = isxMobile ? '360' : '1400';
  var hbnoh = isxMobile ? '156' : '600';
  $('#banner-image-only').append("<img width='"+hbnow+"' and height='"+hbnoh+"' style='width: 100%;height:auto;' src='"+hbno+"' class='img-responsive'/>");

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-two-columns-with-images"] && !window.DesignMode) return;
  try {
    
$(document).ready(function() {
  $(window).scroll(function(){
    $('.background-cimg').each(function(){
        if (!$(this).hasClass('bgadd')) { 
          $(this).addClass('bgadd');
          $(this).append('<img alt="' + $(this).data('alt') + '" class="img-responsive" src="' + $(this).data('img') + '"/>');
        }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["google-reviews"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
      var gvslider = $('.google-views-container').slick({
        infinite: true,
        lazyLoad: 'ondemand',
        slidesToShow: 3,
        autoplay:true,
  		autoplaySpeed: 8000,
        slidesToScroll: 1,
        arrows:true,
        dots: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        onInit: function(slick){
            slick.$slides.each(function(index, slide){
               console.log('slide #' + index + ' has been clicked!');
            });
        },
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    });
  
    const colors = ['#B4009E','#5C2D91','#0078D7','#00B4FF','#008272','#107C10','#00AA55', '#009FD4', '#B381B3', '#939393', '#E3BC00', '#D47500', '#DC2A2A'];

    function numberFromText(text) {
      // numberFromText("AA");
      const charCodes = text
        .split('') // => ["A", "A"]
        .map(char => char.charCodeAt(0)) // => [65, 65]
        .join(''); // => "6565"
      return parseInt(charCodes, 10);
    }

  function AddReadMore() {
    //This limit you can set after how much characters you want to show Read More.
    var carLmt = 320;
    // Text to show when text is collapsed
    var readMoreTxt = " ... read more";
    // Text to show when text is expanded
    var readLessTxt = " read less";
    //Traverse all selectors with this class and manupulate HTML part to show Read More
    $(".gv-testimonial-text").each(function() {
        if ($(this).find(".firstSec").length)
            return;
        var allstr = $(this).text();
        if (allstr.length > carLmt) {
            var firstSet = allstr.substring(0, carLmt);
            var secdHalf = allstr.substring(carLmt, allstr.length);
            var strtoadd = firstSet + "<span class='SecSec'>" + secdHalf + "</span><span class='readMore'  title='Click to Show More'>" + readMoreTxt + "</span><span class='readLess' title='Click to Show Less'>" + readLessTxt + "</span>";
            $(this).html(strtoadd);
        }
    });
    //Read More and Read Less Click Event binding
    $(document).on("click", ".readMore,.readLess", function() {
        $(this).closest(".gv-testimonial-text").toggleClass("showlesscontent showmorecontent");
    });
  }
  $(function() {
     //Calling function after Page Load
     var slxt = {};
     let scgv = true;
     $(window).scroll(function(){
       if (scgv) {
         $.each( slxt, function( key, value ) {
              const gvdata = value;
              if (typeof gvdata.split("tasyo") != 'undefined') {
              const dxv = gvdata.split("tasyo");
              var authorname = dxv[0]
              var googlereviews = dxv[1];
                //$('.google-views-container').slick("slickAdd", '<div class="g-testimonial" data-duration="5000"><div class="testimonial-inside"><div class="testimonial-author"><div class="testimonial-author-name"><a>'+authorname+'</a></div><div class="testimonial-author-photo"><span class="g-avatar">'+authorname.slice(-2)+'</span></div></div><div class="testimonial-text gv-testimonial-text showlesscontent">'+googlereviews+'</div></div><div class="gr-ratings"><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span></div></div>');
              }
         });
         AddReadMore(); 
          const avatars = document.querySelectorAll('.g-avatar');
          avatars.forEach(avatar => {
            const text = avatar.innerText; // => "AA"
            avatar.style.backgroundColor = colors[numberFromText(text) % colors.length]; // => "#DC2A2A"
          });
       }
       scgv = false;
      });
  });

  } catch(e) { console.error(e); }
})();
})();
